import AppIcon from "@/components/AppIcon";
import { CurrencyValue } from "@/components/tableElements";
import AppPopover from "@/components/AppPopover";
import PpcBudgetAllocationCircle from "@/components/PpcBudgetAllocationCircle";
import PercentageValue from "@/components/tableElements/PercentageValue";
export default {
  name: 'PpcBAMaxPotentialPercentCell',
  components: {
    AppIcon,
    CurrencyValue,
    AppPopover,
    PpcBudgetAllocationCircle,
    PercentageValue
  },
  props: {
    item_id: {
      type: String,
      default: ""
    },
    currency: {
      type: String,
      default: ""
    },
    currency_precision: {
      type: String,
      default: ""
    },
    value: {
      type: Number
    },
    potential_budget: {
      type: Number
    },
    current_budget: {
      type: Number
    }
  },
  computed: {
    getPotentialColor() {
      return value => {
        if (value * 100 >= 90) return "color-green";
        if (value * 100 >= 60) return "color-yellow";
        return "color-red";
      };
    },
    getPotentialWidth() {
      return value => {
        return value * 100 > 100 ? 100 : value * 100;
      };
    }
  }
};